import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "optionList", "hiddenInput"]

  connect() {
    this.options = this.hiddenInputTarget.value ? JSON.parse(this.hiddenInputTarget.value) : []
    this.renderOptions()
  }

  addOption(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()

      const value = this.inputTarget.value.trim().replace(/,/g, "")
      if (value && !this.options.includes(value)) {
        this.options.push(value)
        this.updateHiddenField()
        this.renderOptions()
      }

      this.inputTarget.value = ""
    }
  }

  removeOption(event) {
    const index = event.currentTarget.dataset.index
    this.options.splice(index, 1)
    this.updateHiddenField()
    this.renderOptions()
  }

  updateHiddenField() {
    this.hiddenInputTarget.value = JSON.stringify(this.options)
  }

  renderOptions() {
    this.optionListTarget.innerHTML = ""

    this.options.forEach((option, index) => {
      const optionElement = document.createElement("span")
      optionElement.className = "inline-flex items-center pl-2 py-1 text-t6 leading-[1.5] bg-trina-green-100 text-trina-slate-300 mr-2 mb-2"
      optionElement.innerHTML = `
        ${option}
        <button type="button" data-action="click->array-options#removeOption" data-index="${index}" class="ml-1 text-trina-slate-300 hover:text-trina-slate-100 px-3 text-3xl pb-1">
          &times;
        </button>
      `
      this.optionListTarget.appendChild(optionElement)
    })
  }
}
